import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { url } from './../../shared/urls/url';

@Injectable({
  providedIn: 'root'
})
export class SelectFiltreService {

  // URLString = 'http://localhost:50810';
  constructor(private http: HttpClient, private URLString: url) { }
  httpOptions = {
    headers: new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('TokenServe'), responseType: 'arraybuffer', })
  };

  TypeSearch(typeSearch) {

    const url = this.URLString.apibackdavid + '/api/SelectFiltre/TypeSearch/' + typeSearch;

    return this.http.get(url, this.httpOptions);
  }
}
